import { BasePageModel, basePageToLocal } from './base';
import {
  TrainingPhraseConfig,
  trainingPhraseToLocal,
  trainingPhraseToServer
} from './training-phrase';

import { OriginKey, originKeyToLocal } from './index';

export interface AttributeCompanion extends BasePageModel {
  multiValue: boolean;
  expressions: TrainingPhraseConfig[];
}

export function attributeCompanionToLocal(res: any) {

  return {
    ...basePageToLocal(res),
    multiValue: res.multi_value,
    expressions: res.expressions && res.expressions.map(trainingPhraseToLocal) || []
  };
}

export function attributeCompanionToServer(data: AttributeCompanion) {

  return {
    owner_id: data.ownerId,
    owner_type: data.ownerType,
    frame_id: data.frameId,
    agent_id: data.agentId,
    id: data.id,
    name: data.name,
    multi_value: data.multiValue,
    expressions: data.expressions && data.expressions.map(trainingPhraseToServer) || [],
    to_be_deleted: data.toBeDeleted
  };
}
